export default __webpack_public_path__ + "locales/ru/DeleteDialog.json?hash=f937afd0d7a19b725def8e4c169d719a";